import { IonItem, IonToggle } from "@ionic/react";

import React, { forwardRef, useEffect, useState } from "react";
import Sheet from "react-modal-sheet";
import { useDispatch, useSelector } from "react-redux";
import "react-responsive-modal/styles.css";
import { useNavigate } from "react-router-dom";
import {
  setEditEmployees,
  setEditEmployeeData,
} from "redux/container/userSlice";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import CancelPopUp from "assets/images/icon/svg/CancelPopUp";
import { ClipLoader } from "react-spinners";
import Business from "services/Business";
import TextInputWithIcon from "../Common/TextInputWithIcon";
import Product from "services/Product";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Accounts from "services/Accounts";
import { getUserBusiness } from "config/user";
import Payment from "services/Payment";
import Select from "react-select";
export default function EditEmpBottomSheet({
  employee,
  employeeSalary,
  getEmployees,
  employees,
  getEmployeesSalaryList,
  getEmployeesLeaveList,
}) {
  const ref = React.useRef();
  const isOpenBottomSheet = useSelector((state) => state.user.editEmployees);
  const ekkLanguage = useSelector((state) => state.lan.lan);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [cancelLoader, setCancelLoader] = useState(false);
  const [salaryAmount, setSalaryAmount] = useState(0);

  const [isHourly, setIsHourly] = useState(null);
  const [salaryAmountEmpty, setSalaryAmountEmpty] = useState("");
  const onOpenModal = () => setIsOpen(true);
  const onCloseModal = () => setIsOpen(false);

  const [isOpenSalary, setIsOpenSalary] = useState(false);
  const [cancelLoaderSalary, setCancelLoaderSalary] = useState(false);
  const onOpenSalaryModal = () => setIsOpenSalary(true);
  const onCloseSalaryModal = () => setIsOpenSalary(false);
  const [totalWorkingHours, setTotalWorkingHours] = useState("00:00:00");
  const [selectedHours, setSelectedHours] = useState(null);
  const dateFormat = useSelector((state) => state.date.format);
  const [editHoursLoader, setEditHoursLoader] = useState(false);
  const business = getUserBusiness();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [salaryPayoutAmount, setSalaryPayoutAmount] = useState(0);
  const [payoutDescription, setPayoutDescription] = useState("");
  const [salaryPayoutAmountEmpty, setSalaryPayoutAmountEmpty] = useState("");
  const [salaryPayoutLoader, setSalaryPayoutLoader] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalWeeklyAmount, setTotalWeeklyAmount] = useState(0);
  const [selectedLeaveDate, setSelectedLeaveDate] = useState(null);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [selectedLeaveDescription, setSelectedLeaveDescription] =
    useState(null);

  const deleteHandler = async () => {
    setCancelLoader(true);
    let response = await Business.deleteEmployee(employee.id);
    if (response.status === 200) {
      dispatch(setEditEmployees(false));
      navigate("/employees-list");
      setCancelLoader(false);
    } else {
      setCancelLoader(false);
    }
  };

  const editSalaryHandler = async () => {
    if (salaryAmount) {
      setCancelLoaderSalary(true);
      let req_body = {
        amount: salaryAmount,
        salary_type: isHourly ? "Hourly" : "Monthly",
      };
      let response = await Product.updateEmployeeSalary(employee.id, req_body);
      if (response.status === 200 || response.status === 201) {
        setCancelLoaderSalary(false);
        onCloseSalaryModal();
        dispatch(setEditEmployees(false));
        getEmployees();
        toast.success("Salary updated successfully");
        setSalaryAmountEmpty("");
      } else {
        setCancelLoaderSalary(false);
      }
    } else {
      setSalaryAmountEmpty("Please enter salary amount");
    }
  };

  const handleToggleChange = (e) => {
    setIsHourly(e.detail.checked);
  };

  useEffect(() => {
    setSalaryAmount(Number(employeeSalary?.amount)?.toFixed(2));
    setIsHourly(employeeSalary?.salary_type == "Hourly");
  }, [employeeSalary]);

  const [isOpenEditHoursModel, setIsOpenEditHoursModel] = useState(false);
  const onCloseModalEditHoursModel = () => {
    setTotalWorkingHours("00:00:00");
    setIsOpenEditHoursModel(false);
  };
  const onOpenModalEditHoursModel = () => setIsOpenEditHoursModel(true);
  const [isOpenSalaryPayoutModel, setIsOpenSalaryPayoutModel] = useState(false);
  const onOpenSalaryPayoutModel = () => setIsOpenSalaryPayoutModel(true);
  const onCloseSalaryPayoutModel = () => setIsOpenSalaryPayoutModel(false);
  const [isOpenLeaveModel, setIsOpenLeaveModel] = useState(false);
  const onOpenLeaveModel = () => setIsOpenLeaveModel(true);
  const onCloseLeaveModel = () => setIsOpenLeaveModel(false);
  let [amountInfoLoader, setAmountInfoLoader] = useState(false);
  let [leftLineLoader, setLeftLineLoader] = useState(false);
  let [rightLineLoader, setRightLineLoader] = useState(false);
  let [leaveLoader, setLeaveLoader] = useState(false);
  let [selectedLeaveTypeValue, setSelectedLeaveTypeValue] = useState(null);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0px",
      width: "calc(100% - 20px)",
      transition: ".4s all ease",
      borderRadius: 12,
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      transition: ".4s all ease",
      backgroundColor: "rgba(0,0,0,.5)",
      overflow: "auto",
    },
  };
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div
      ref={ref}
      className={`p-3 block mt-4 example-custom-input pl-4 h-[50px] rounded-[5px] bg-F8F8F8  w-full border border-black-500`}
      onClick={onClick}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center ">
          {selectedHours?.check_in_time
            ? moment(selectedHours?.check_in_time).format(
                `${dateFormat}-HH:mm:ss`
              )
            : "Select Time and Date"}
        </div>
      </div>
    </div>
  ));
  const ExampleCustomInput2 = forwardRef(({ value, onClick }, ref) => (
    <div
      ref={ref}
      className={`p-3 block mt-4 example-custom-input pl-4 h-[50px] rounded-[5px] bg-F8F8F8  w-full border border-black-500`}
      onClick={onClick}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center ">
          {selectedHours?.check_out_time
            ? moment(selectedHours?.check_out_time).format(
                `${dateFormat}-HH:mm:ss`
              )
            : "Select Time and Date"}
        </div>
      </div>
    </div>
  ));
  let dateChanger = (date, type) => {
    let updatedHours;
    if (type === "start") {
      updatedHours = {
        ...selectedHours,
        check_in_time: date,
      };
    } else {
      updatedHours = {
        ...selectedHours,
        check_out_time: date,
      };
    }
    setSelectedHours(updatedHours);

    // Calculate total hours if both dates exist
    if (updatedHours.check_in_time && updatedHours.check_out_time) {
      const start = moment(updatedHours.check_in_time);
      const end = moment(updatedHours.check_out_time);
      const duration = moment.duration(end.diff(start));

      const hours = Math.floor(duration.asHours()).toString().padStart(2, "0");
      const minutes = duration.minutes().toString().padStart(2, "0");
      const seconds = duration.seconds().toString().padStart(2, "0");

      setTotalWorkingHours(`${hours}:${minutes}:${seconds}`);
    }
  };
  const addHoursSubmit = async () => {
    setEditHoursLoader(true);
    let payload = {
      business_id: business?.id,
      created_by: employees?.user_id,
      visit_type: "Hub Working",
      check_out_time: moment(selectedHours?.check_out_time).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      ),
      check_in_time: moment(selectedHours?.check_in_time).format(
        "YYYY-MM-DDTHH:mm:ssZ"
      ),
      timezone: timeZone,
    };

    let response = await Accounts.employeeCheck(payload);
    if (response.success) {
      setSelectedHours(null);
      getEmployees();
      setEditHoursLoader(false);
      toast.success("Working hours added successfully");
      onCloseModalEditHoursModel();
      dispatch(setEditEmployees(false));
    } else {
      setEditHoursLoader(false);
    }
  };
  const [currentWeekStart, setCurrentWeekStart] = useState(
    moment().startOf("week")
  );
  const [currentWeekEnd, setCurrentWeekEnd] = useState(moment());
  const previousWeekHandler = () => {
    setLeftLineLoader(true);
    const newStart = moment(currentWeekStart)
      .subtract(1, "week")
      .startOf("week");
    const newEnd = moment(currentWeekStart).subtract(1, "day");

    setCurrentWeekStart(newStart);
    setCurrentWeekEnd(newEnd);

    handleEmployeeHoursClick(
      employees?.user_id,
      moment(newStart).format("YYYY-MM-DD"),
      moment(newEnd).format("YYYY-MM-DD")
    );
  };
  const nextWeekHandler = () => {
    setRightLineLoader(true);
    const today = moment();
    const newStart = moment(currentWeekStart).add(1, "week").startOf("week");
    const newEnd = moment(currentWeekEnd).add(1, "week");

    // Allow going to current week even if it's not complete
    if (newStart.isSameOrBefore(today)) {
      const endDate = newEnd.isAfter(today) ? today : newEnd;
      setCurrentWeekStart(newStart);
      setCurrentWeekEnd(endDate);
      handleEmployeeHoursClick(
        employees?.user_id,
        moment(newStart).format("YYYY-MM-DD"),
        moment(endDate).format("YYYY-MM-DD")
      );
    }
  };
  const handleEmployeeHoursClick = async (userId, start, end) => {
    setAmountInfoLoader(true);
    let response = await Product.getEmployeeHours(userId, start, end);
    if (response.status === 200) {
      setAmountInfoLoader(false);
      setLeftLineLoader(false);
      setRightLineLoader(false);
      setTotalAmount(response?.total_working_hours);
      setTotalWeeklyAmount(response?.total_salary);
    } else {
      setLeftLineLoader(false);
      setRightLineLoader(false);
      setAmountInfoLoader(false);
      setTotalAmount(0);
      setTotalWeeklyAmount(0);
    }
  };
  const salaryPayoutHandler = async () => {
    if (!salaryPayoutAmount) {
      setSalaryPayoutAmountEmpty("Please enter salary payout amount");
      return;
    }
    setSalaryPayoutLoader(true);
    let payload = {
      business_id: business?.id,
      emp_id: employees?.id,
      user_id: employees?.user_id,
      salary_type: "Weekly",
      amount: salaryPayoutAmount,
      start_date: moment(currentWeekStart).format("YYYY-MM-DD"),
      end_date: moment(currentWeekEnd).format("YYYY-MM-DD"),
      description: payoutDescription,
      emp_name: employees?.display_name,
      total_salary: totalWeeklyAmount,
      salary: salaryAmount,
      total_working_hour: totalAmount,
    };
    let response = await Payment.salaryPayout(payload);
    if (response.success) {
      setSalaryPayoutAmount(0);
      setPayoutDescription("");
      setSalaryPayoutLoader(false);
      toast.success("Salary payout successfully");
      getEmployeesSalaryList(employees?.id);
      onCloseSalaryPayoutModel();
      dispatch(setEditEmployees(false));
      let newStart = moment().startOf("week").format("YYYY-MM-DD");
      let endDate = moment().endOf("week").format("YYYY-MM-DD");
      handleEmployeeHoursClick(employees?.user_id, newStart, endDate);
    } else {
      toast.error("Salary payout failed");
      setSalaryPayoutLoader(false);
    }
  };

  useEffect(() => {
    handleEmployeeHoursClick(
      employees?.user_id,
      moment(currentWeekStart).format("YYYY-MM-DD"),
      moment(currentWeekEnd).format("YYYY-MM-DD")
    );
  }, []);

  const LeaveCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div
      ref={ref}
      className={`p-3 block mt-4 example-custom-input pl-4 h-[50px] rounded-[5px] bg-F8F8F8  w-full border border-black-500`}
      onClick={onClick}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center ">
          {selectedLeaveDate?.start_date
            ? moment(selectedLeaveDate?.start_date).format(dateFormat)
            : "Select Start Date"}
        </div>
      </div>
    </div>
  ));
  const LeaveCustomInput2 = forwardRef(({ value, onClick }, ref) => (
    <div
      ref={ref}
      className={`p-3 block mt-4 example-custom-input pl-4 h-[50px] rounded-[5px] bg-F8F8F8  w-full border border-black-500`}
      onClick={onClick}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center ">
          {selectedLeaveDate?.end_date
            ? moment(selectedLeaveDate?.end_date).format(dateFormat)
            : "Select End Date"}
        </div>
      </div>
    </div>
  ));

  let leaveDateChanger = (date, type) => {
    let updatedLeaveDate;
    if (type === "start") {
      updatedLeaveDate = {
        ...selectedLeaveDate,
        start_date: date,
      };
    } else {
      updatedLeaveDate = {
        ...selectedLeaveDate,
        end_date: date,
      };
    }
    setSelectedLeaveDate(updatedLeaveDate);

    // Calculate total hours if both dates exist
    if (updatedLeaveDate.start_date && updatedLeaveDate.end_date) {
      const start = moment(updatedLeaveDate.start_date);
      const end = moment(updatedLeaveDate.end_date);
      const duration = moment.duration(end.diff(start));

      const days = Math.floor(duration.asDays());
      setSelectedLeaveDate({
        ...updatedLeaveDate,
        duration: days + 1,
      });
    }
  };

  const leaveSubmitHandler = async () => {
    setLeaveLoader(true);
    let payload = {
      emp_id: employees?.id,
      emp_name: employees?.display_name,
      start_date: moment(selectedLeaveDate?.start_date).format("YYYY-MM-DD"),
      end_date: moment(selectedLeaveDate?.end_date).format("YYYY-MM-DD"),
      purpose_of_leave: selectedLeaveDescription,
      leave_type: selectedLeaveTypeValue,
      duration: selectedLeaveDate?.duration,
      user_id: employees?.user_id,
      message: `${moment(selectedLeaveDate?.start_date).format(
        dateFormat
      )} to ${moment(selectedLeaveDate?.end_date).format(dateFormat)} (${
        selectedLeaveDate?.duration
      }) leave request submitted for approval is Pending. \n ${selectedLeaveDescription}`,
    };
    let response = await Payment.employeeLeave(payload);
    if (response.success) {
      setLeaveLoader(false);
      toast.success("Leave added successfully");
      onCloseLeaveModel();
      getEmployeesLeaveList(employees?.id);
      dispatch(setEditEmployees(false));
    } else {
      setLeaveLoader(false);
      toast.error("Leave failed");
    }
  };

  let [leaveType, setLeaveType] = useState([]);
  const handleGetLeaveType = async () => {
    let response = await Payment.getLeaveType();
    if (response.success) {
      setLeaveType(
        response?.results.map((item) => ({
          ...item,
          value: item.title,
          label: item.title,
        }))
      );
    } else {
      setLeaveType([]);
    }
  };

  useEffect(() => {
    handleGetLeaveType();
  }, []);

  return (
    <div>
      <Sheet
        className="bottom-sheet"
        initialSnap={1}
        ref={ref}
        isOpen={isOpenBottomSheet}
        snapPoints={[400, 400, 400, 0]}
        onClose={() => dispatch(setEditEmployees(false))}
      >
        <Sheet.Container>
          <Sheet.Header />
          <Sheet.Content>
            <IonItem
              button
              onClick={onOpenSalaryModal}
              lines="none"
              className="my-[5px]"
            >
              <span className="py-[5px]">
                <img
                  className="h-10 w-10"
                  src="/assets/images/edit.png"
                  alt="user"
                />
              </span>
              <p className="text-16 font-bold text-black-1000 pl-2">
                Edit Salary
              </p>
            </IonItem>
            <IonItem
              button
              onClick={() => {
                dispatch(setEditEmployeeData(employee));
                dispatch(setEditEmployees(false));
                navigate(`/update-employee/${employee.id}`);
              }}
              lines="none"
              className="my-[5px]"
            >
              <span className="py-[5px]">
                <img
                  className="h-10 w-10"
                  src="/assets/images/edit.png"
                  alt="user"
                />
              </span>
              <p className="text-16 font-bold text-black-1000 pl-2">
                Edit Employee
              </p>
            </IonItem>
            <IonItem
              button
              onClick={() => {
                onOpenModalEditHoursModel();
              }}
              lines="none"
              className="my-[5px]"
            >
              <span className="py-[5px]">
                <img
                  className="h-10 w-10"
                  src="/assets/images/scheduled_for_delivery.png"
                  alt="time"
                />
              </span>
              <p className="text-16 font-bold text-black-1000 pl-2">
                Add Work Time
              </p>
            </IonItem>
            <IonItem
              button
              onClick={() => {
                let newStart = moment().startOf("week").format("YYYY-MM-DD");
                let endDate = moment().endOf("week").format("YYYY-MM-DD");
                setCurrentWeekStart(moment().startOf("week"));
                setCurrentWeekEnd(moment());
                handleEmployeeHoursClick(employees?.user_id, newStart, endDate);
                onOpenSalaryPayoutModel();
              }}
              lines="none"
              className="my-[5px]"
            >
              <span className="py-[5px] h-10 w-10 rounded-full bg-lime-400 flex items-center justify-center">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 0C5.607 0 0 5.607 0 12.5C0 19.393 5.607 25 12.5 25C19.393 25 25 19.393 25 12.5C25 5.607 19.393 0 12.5 0ZM12.5 22.917C6.758 22.917 2.083 18.242 2.083 12.5C2.083 6.758 6.758 2.083 12.5 2.083C18.242 2.083 22.917 6.758 22.917 12.5C22.917 18.242 18.242 22.917 12.5 22.917Z"
                    fill="#fff"
                  />
                  <path
                    d="M16.667 8.333H8.333C7.643 8.333 7.083 8.893 7.083 9.583C7.083 10.273 7.643 10.833 8.333 10.833H16.667C17.357 10.833 17.917 10.273 17.917 9.583C17.917 8.893 17.357 8.333 16.667 8.333Z"
                    fill="#fff"
                  />
                  <path
                    d="M16.667 11.667H8.333C7.643 11.667 7.083 12.227 7.083 12.917C7.083 13.607 7.643 14.167 8.333 14.167H16.667C17.357 14.167 17.917 13.607 17.917 12.917C17.917 12.227 17.357 11.667 16.667 11.667Z"
                    fill="#fff"
                  />
                  <path
                    d="M13.333 15H8.333C7.643 15 7.083 15.56 7.083 16.25C7.083 16.94 7.643 17.5 8.333 17.5H13.333C14.023 17.5 14.583 16.94 14.583 16.25C14.583 15.56 14.023 15 13.333 15Z"
                    fill="#fff"
                  />
                </svg>
              </span>
              <p className="text-16 font-bold text-black-1000 pl-2">
                Add Salary Payout
              </p>
            </IonItem>
            <IonItem
              button
              onClick={() => {
                onOpenLeaveModel();
              }}
              lines="none"
              className="my-[5px]"
            >
              <span className="py-[5px] h-10 w-10 rounded-full bg-fuchsia-300 flex items-center justify-center">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 0C5.607 0 0 5.607 0 12.5C0 19.393 5.607 25 12.5 25C19.393 25 25 19.393 25 12.5C25 5.607 19.393 0 12.5 0ZM12.5 22.917C6.758 22.917 2.083 18.242 2.083 12.5C2.083 6.758 6.758 2.083 12.5 2.083C18.242 2.083 22.917 6.758 22.917 12.5C22.917 18.242 18.242 22.917 12.5 22.917Z"
                    fill="#fff"
                  />
                  <path
                    d="M18.75 11.458H6.25C5.81 11.458 5.458 11.81 5.458 12.25V12.75C5.458 13.19 5.81 13.542 6.25 13.542H18.75C19.19 13.542 19.542 13.19 19.542 12.75V12.25C19.542 11.81 19.19 11.458 18.75 11.458Z"
                    fill="#fff"
                  />
                  <path
                    d="M10.417 6.25H14.583C15.023 6.25 15.375 6.602 15.375 7.042V17.958C15.375 18.398 15.023 18.75 14.583 18.75H10.417C9.977 18.75 9.625 18.398 9.625 17.958V7.042C9.625 6.602 9.977 6.25 10.417 6.25Z"
                    fill="#fff"
                  />
                </svg>
              </span>
              <p className="text-16 font-bold text-black-1000 pl-2">
                Add Leave
              </p>
            </IonItem>
            <IonItem
              button
              onClick={onOpenModal}
              lines="none"
              className="my-[5px]"
            >
              <span className="py-[5px]">
                <img
                  className="h-10 w-10"
                  src="/assets/images/delete.png"
                  alt="user"
                />
              </span>
              <p className="text-16 font-bold text-black-1000 pl-2">
                Delete Employee
              </p>
            </IonItem>
          </Sheet.Content>
        </Sheet.Container>

        <Sheet.Backdrop onClick={() => dispatch(setEditEmployees(false))} />
      </Sheet>
      <Modal
        open={isOpen}
        onClose={onCloseModal}
        classNames="bottom-sheet-modal"
      >
        <div className="p-5">
          <span className="mb-2 inline-block mx-2">
            <CancelPopUp />
          </span>
          <h6 className="text-16 font-bold pb-[10px]">
            {ekkLanguage.createEmployees.deleteConformationAsk}
          </h6>

          <div className="flex">
            <button
              className="border-2 font-bold h-10 rounded-[7px] w-1/2 mr-2 text-black-1000 border-black-200 border-solid"
              onClick={onCloseModal}
            >
              {ekkLanguage.orderDetails.noBtn}
            </button>
            <button
              color="primary"
              className="font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-primary text-white"
              onClick={!cancelLoader && deleteHandler}
            >
              {cancelLoader ? (
                <ClipLoader
                  sizeUnit={"px"}
                  size={20}
                  color={"white"}
                  loading={true}
                />
              ) : (
                ekkLanguage.orderDetails.yesBtn
              )}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        open={isOpenSalary}
        onClose={onCloseSalaryModal}
        classNames="bottom-sheet-modal"
      >
        <div className="p-5">
          <h6 className="text-16 font-bold pb-[10px]">Edit Salary</h6>

          <div className="text-left flex items-center justify-between">
            <h5 className="text-dark-1000 text-16 mb-3 font-semibold">
              Salary Type
            </h5>
            <div>
              <IonToggle
                labelPlacement="start"
                height="100"
                aria-label="Primary toggle"
                size="large"
                color="success"
                checked={isHourly}
                onIonChange={handleToggleChange}
              >
                <span className="font-bold text-14">
                  {isHourly ? "Hourly" : "Monthly"}
                </span>
              </IonToggle>
            </div>
          </div>

          <div className="text-left mb-4">
            <h5 className="text-dark-1000 text-16 mb-3 font-semibold">
              Salary
            </h5>

            <TextInputWithIcon
              type="number"
              inputText={salaryAmount}
              setInputText={setSalaryAmount}
              placeholder={`Enter salary ${
                isHourly ? "hourly" : "monthly"
              } amount`}
            />
            {salaryAmountEmpty && (
              <p className="text-red-500 text-12">{salaryAmountEmpty}</p>
            )}
          </div>

          <div className="flex">
            <button
              className="border-2 font-bold h-10 rounded-[7px] w-1/2 mr-2 border-solid bg-primary text-white"
              onClick={onCloseSalaryModal}
            >
              Cancel
            </button>
            <button
              color="success"
              className="font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-success text-white"
              onClick={!cancelLoaderSalary && editSalaryHandler}
            >
              {cancelLoaderSalary ? (
                <ClipLoader
                  sizeUnit={"px"}
                  size={20}
                  color={"white"}
                  loading={true}
                />
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        style={customStyles}
        open={isOpenEditHoursModel}
        onClose={() => setIsOpenEditHoursModel(false)}
        // classNames='bottom-sheet-modal'
      >
        <div className="p-5">
          <div>
            <div className="pb-5">
              <div className="flex">
                <h4 className="font-bold text-14">Start Date Time</h4>
              </div>
              <DatePicker
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="dd/MM/yyyy HH:mm"
                selected={
                  selectedHours?.check_in_time
                    ? moment(selectedHours.check_in_time).toDate()
                    : new Date()
                }
                onChange={(date) => dateChanger(date, "start")}
                customInput={<ExampleCustomInput />}
                withPortal
                timeCaption="T(24H)"
              />
            </div>
            <div className="pb-5">
              <div className="flex">
                <h4 className="font-bold text-14">End Date Time</h4>
              </div>
              <DatePicker
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="MMMM d, yyyy h:mm aa"
                selected={
                  selectedHours?.check_out_time
                    ? moment(selectedHours.check_out_time).toDate()
                    : selectedHours?.check_in_time
                    ? moment(selectedHours.check_in_time).toDate()
                    : new Date()
                }
                onChange={(date) => dateChanger(date, "end")}
                customInput={<ExampleCustomInput2 />}
                withPortal
                timeCaption="T(24H)"
                minDate={
                  selectedHours?.check_in_time
                    ? moment(selectedHours.check_in_time).toDate()
                    : new Date()
                }
              />
            </div>
            <div className="pb-5">
              <div className="flex">
                <h4 className="font-bold text-14">
                  Total Working Hours: {totalWorkingHours}
                </h4>
              </div>
            </div>
          </div>

          <div className="flex">
            <button
              className=" font-bold h-10 bg-primary rounded-[7px] w-1/2 mr-2 text-white  border-solid"
              onClick={() => {
                setSelectedHours(null);
                onCloseModalEditHoursModel();
              }}
            >
              {ekkLanguage.orderDetails.noBtn}
            </button>
            <button
              color="primary"
              className="font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-success text-white"
              onClick={addHoursSubmit}
            >
              {editHoursLoader ? (
                <ClipLoader
                  sizeUnit={"px"}
                  size={20}
                  color={"white"}
                  loading={true}
                />
              ) : (
                ekkLanguage.orderDetails.yesBtn
              )}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        open={isOpenSalaryPayoutModel}
        onClose={onCloseSalaryPayoutModel}
        classNames="bottom-sheet-modal"
      >
        <div className="p-5">
          <h6 className="text-16 font-bold pb-[10px]"> Salary Payout</h6>

          <div className="flex justify-between py-3 items-center">
            <button
              className="font-bold h-9 w-9 rounded-[5px] border-2 bg-success text-white px-2 text-12 flex items-center justify-center"
              onClick={!amountInfoLoader && previousWeekHandler}
            >
              {amountInfoLoader && leftLineLoader ? (
                <ClipLoader
                  sizeUnit={"px"}
                  size={15}
                  color={"white"}
                  loading={true}
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="8"
                  viewBox="0 0 10 8"
                  fill="none"
                >
                  <path
                    d="M8.66667 3.33337H2L4.19333 1.14004C4.25582 1.07806 4.30541 1.00433 4.33926 0.92309C4.37311 0.841851 4.39053 0.754714 4.39053 0.666706C4.39053 0.578698 4.37311 0.491561 4.33926 0.410322C4.30541 0.329082 4.25582 0.255348 4.19333 0.193373C4.06842 0.069206 3.89946 -0.000488281 3.72333 -0.000488281C3.54721 -0.000488281 3.37824 0.069206 3.25333 0.193373L0.393333 3.06004C0.142942 3.30894 0.00148853 3.64698 0 4.00004V4.00004C0.00324439 4.35077 0.144563 4.6861 0.393333 4.93337L3.25333 7.80003C3.31549 7.86175 3.3892 7.91063 3.47025 7.94386C3.55129 7.9771 3.63809 7.99404 3.72569 7.99373C3.81329 7.99343 3.89996 7.97586 3.98077 7.94206C4.06159 7.90825 4.13495 7.85886 4.19667 7.7967C4.25839 7.73454 4.30726 7.66083 4.3405 7.57978C4.37373 7.49874 4.39068 7.41194 4.39037 7.32434C4.39006 7.23674 4.3725 7.15007 4.33869 7.06926C4.30489 6.98845 4.25549 6.91509 4.19333 6.85337L2 4.6667H8.66667C8.84348 4.6667 9.01305 4.59646 9.13807 4.47144C9.2631 4.34641 9.33333 4.17685 9.33333 4.00004C9.33333 3.82322 9.2631 3.65366 9.13807 3.52863C9.01305 3.40361 8.84348 3.33337 8.66667 3.33337Z"
                    fill="white"
                  />
                </svg>
              )}
            </button>

            <div className="flex justify-between items-center mb-1 mt-1">
              <h4 className="font-bold text-14 text-black-1000 ml-1.5">
                {moment(currentWeekStart, "YYYY-MM-DD").format(dateFormat)} -{" "}
                {moment(currentWeekEnd, "YYYY-MM-DD").format(dateFormat)}
              </h4>
            </div>

            <button
              className={`font-bold h-9 w-9 rounded-[5px] ml-2 border-2 flex items-center justify-center ${
                currentWeekEnd.isSameOrAfter(moment(), "day")
                  ? "bg-36A94D-333"
                  : "bg-success"
              }  text-white px-2 text-12`}
              onClick={!amountInfoLoader && nextWeekHandler}
              disabled={currentWeekEnd.isSameOrAfter(moment(), "day")}
            >
              {amountInfoLoader && rightLineLoader ? (
                <ClipLoader
                  sizeUnit={"px"}
                  size={15}
                  color={"white"}
                  loading={true}
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="8"
                  viewBox="0 0 10 8"
                  fill="none"
                >
                  <path
                    d="M1.33333 3.33337H8L5.80667 1.14004C5.74418 1.07806 5.69459 1.00433 5.66074 0.92309C5.62689 0.841851 5.60947 0.754714 5.60947 0.666706C5.60947 0.578698 5.62689 0.491561 5.66074 0.410322C5.69459 0.329082 5.74418 0.255348 5.80667 0.193373C5.93158 0.069206 6.10054 -0.000488281 6.27667 -0.000488281C6.45279 -0.000488281 6.62176 0.069206 6.74667 0.193373L9.60667 3.06004C9.85706 3.30894 9.99851 3.64698 10 4.00004V4.00004C9.99676 4.35077 9.85544 4.6861 9.60667 4.93337L6.74667 7.80003C6.68451 7.86175 6.6108 7.91063 6.52975 7.94386C6.44871 7.9771 6.36191 7.99404 6.27431 7.99373C6.18671 7.99343 6.10004 7.97586 6.01923 7.94206C5.93841 7.90825 5.86505 7.85886 5.80333 7.7967C5.74161 7.73454 5.69274 7.66083 5.6595 7.57978C5.62627 7.49874 5.60932 7.41194 5.60963 7.32434C5.60994 7.23674 5.6275 7.15007 5.66131 7.06926C5.69511 6.98845 5.74451 6.91509 5.80667 6.85337L8 4.6667H1.33333C1.15652 4.6667 0.986953 4.59646 0.861929 4.47144C0.736905 4.34641 0.666667 4.17685 0.666667 4.00004C0.666667 3.82322 0.736905 3.65366 0.861929 3.52863C0.986953 3.40361 1.15652 3.33337 1.33333 3.33337Z"
                    fill="white"
                  />
                </svg>
              )}
            </button>
          </div>

          <h5 className="text-dark-1000 text-16 font-semibold">
            Hours Worked: {totalAmount}
          </h5>
          <h5 className="text-dark-1000 text-16 font-semibold">
            Salary: ${employeeSalary?.amount}/{employeeSalary?.salary_type}
          </h5>
          <h5 className="text-dark-1000 text-16 font-semibold mb-3">
            Total: ${Number(totalWeeklyAmount).toFixed(2)}
          </h5>
          <div className="text-left">
            <h5 className="text-dark-1000 text-16 mb-2 font-semibold">
              Amount
            </h5>
            <TextInputWithIcon
              type="number"
              inputText={salaryPayoutAmount}
              setInputText={setSalaryPayoutAmount}
              placeholder={`Enter salary payout amount`}
            />
            {salaryPayoutAmountEmpty && (
              <p className="text-red-500 text-12">{salaryPayoutAmountEmpty}</p>
            )}
          </div>
          <div className="text-left">
            <h5 className="text-dark-1000 text-16 mb-2 font-semibold">
              Description
            </h5>

            <TextInputWithIcon
              type="text"
              inputText={payoutDescription}
              setInputText={setPayoutDescription}
              placeholder={`Enter payout description`}
            />
          </div>
          <div className="text-left mb-4">
            <p className="text-red-500 text-12">
              **Expense record for this payout will auto created
            </p>
          </div>

          <div className="flex">
            <button
              className="border-2 font-bold h-10 rounded-[7px] w-1/2 mr-2 border-solid bg-primary text-white"
              onClick={() => {
                onCloseSalaryPayoutModel();
              }}
            >
              Cancel
            </button>
            <button
              color="success"
              className="font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-success text-white"
              onClick={!salaryPayoutLoader && salaryPayoutHandler}
            >
              {salaryPayoutLoader ? (
                <ClipLoader
                  sizeUnit={"px"}
                  size={20}
                  color={"white"}
                  loading={true}
                />
              ) : (
                "Payout"
              )}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        style={customStyles}
        open={isOpenLeaveModel}
        onClose={() => setIsOpenLeaveModel(false)}
        // classNames='bottom-sheet-modal'
      >
        <div className="p-5">
          <div>
            <h6 className="text-16 font-bold pb-[10px]">Add Leave</h6>
            <div className="pb-3">
              <div className="flex">
                <h4 className="font-bold text-14">Start Date</h4>
              </div>
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={
                  selectedLeaveDate?.start_date
                    ? moment(selectedLeaveDate.start_date).toDate()
                    : new Date()
                }
                onChange={(date) => leaveDateChanger(date, "start")}
                customInput={<LeaveCustomInput />}
                withPortal
              />
            </div>
            <div className="pb-2">
              <div className="flex">
                <h4 className="font-bold text-14">End Date</h4>
              </div>
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={
                  selectedLeaveDate?.end_date
                    ? moment(selectedLeaveDate.end_date).toDate()
                    : selectedLeaveDate?.start_date
                    ? moment(selectedLeaveDate.start_date).toDate()
                    : new Date()
                }
                onChange={(date) => leaveDateChanger(date, "end")}
                customInput={<LeaveCustomInput2 />}
                withPortal
                minDate={
                  selectedLeaveDate?.start_date
                    ? moment(selectedLeaveDate.start_date).toDate()
                    : new Date()
                }
              />
            </div>
            <div className="pb-2 pt-2">
              <div className="flex">
                <h4 className="font-bold text-14">
                  Duration: {selectedLeaveDate?.duration} days
                </h4>
              </div>
            </div>

            <div className="text-left">
              <h5 className="text-dark-1000 text-16 mb-2 font-semibold">
                Type
              </h5>

              <Select
                value={
                  selectedLeaveType
                    ? {
                        value: selectedLeaveType,
                        label: selectedLeaveType,
                      }
                    : null
                }
                onChange={(option) => {
                  setSelectedLeaveTypeValue(option.id);
                  setSelectedLeaveType(option.value);
                }}
                options={leaveType}
                placeholder="Select leave type"
                className="basic-single"
                classNamePrefix="select"
                styles={{
                  control: (base) => ({
                    ...base,
                    height: "50px",
                    borderColor: "#00000080",
                    boxShadow: "none",
                    "&:hover": {
                      borderColor: "#00000080",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    height: "50px",
                  }),
                }}
              />
            </div>

            <div className="text-left">
              <h5 className="text-dark-1000 text-16 mb-2 font-semibold">
                Description
              </h5>

              <TextInputWithIcon
                type="text"
                inputText={selectedLeaveDescription}
                setInputText={setSelectedLeaveDescription}
                placeholder={`Enter leave description`}
              />
            </div>
          </div>

          <div className="flex">
            <button
              className=" font-bold h-10 bg-primary rounded-[7px] w-1/2 mr-2 text-white  border-solid"
              onClick={() => {
                setSelectedLeaveDate(null);
                setSelectedLeaveType(null);
                setSelectedLeaveDescription(null);
                onCloseLeaveModel();
              }}
            >
              {ekkLanguage.orderDetails.noBtn}
            </button>
            <button
              color="primary"
              className="font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-success text-white"
              onClick={!leaveLoader && leaveSubmitHandler}
            >
              {leaveLoader ? (
                <ClipLoader
                  sizeUnit={"px"}
                  size={20}
                  color={"white"}
                  loading={true}
                />
              ) : (
                ekkLanguage.orderDetails.yesBtn
              )}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
